import CreditCardLanding from 'components/Content/CreditCards/CreditCardLanding/CreditCardLanding';
import { withCreditCardLandingProps } from 'viewModel/content/creditCards/creditCardsLanding/withCreditCardLandingProps';

export default withCreditCardLandingProps(CreditCardLanding);
